import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/brand/Logo";
import { Footer } from "../components/layout/Footer";
import { SITE } from "../config/site";

const L = SITE.legal;

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Who we are", `This website is operated by ${L.companyName}, ${L.registeredAddress} ("TOYAM", "we").`],
      ["What we collect", "When you submit an enquiry we collect your name, company, work email, phone number, city, business type, enquiry details and your consent timestamp. We also record basic technical data (such as IP address) to protect the form against spam."],
      ["Why we use it", "Solely to review and respond to your enquiry, discuss a potential partnership, and keep records of our business correspondence."],
      ["Retention", "Enquiry details are retained only as long as needed for the enquiry workflow and related business records, after which they are deleted. [Confirm retention period]."],
      ["Sharing", "We do not sell your data. Details may be processed by our hosting and email service providers strictly to deliver the enquiry workflow."],
      ["Your rights", `You may request access, correction or deletion of your data by writing to ${L.grievanceEmail}. This policy is intended to be reviewed against India's Digital Personal Data Protection Act, 2023.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Use of this website", `This website is provided by ${L.companyName} for information about TOYAM's proposed hospitality water offering.`],
      ["Product information", "TOYAM is a brand in development. Product imagery represents design concepts; specifications, availability, classification and pricing are subject to confirmation and applicable Indian food-safety and labelling requirements."],
      ["No offer", "Nothing on this website constitutes a binding offer. Any supply, sampling or co-branding arrangement will be governed by a separate written agreement."],
      ["Intellectual property", "The TOYAM name, logo, bottle design concept and website content belong to their respective owners and may not be reused without permission."],
      ["Governing law", "These terms are governed by the laws of India. [Confirm jurisdiction]."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  useEffect(() => {
    document.title = `${c.title} | TOYAM`;
    return () => { document.title = "TOYAM Alkaline Water in Glass Bottles for Hotels | Agra"; };
  }, [c.title]);
  return (
    <>
      <header className="bg-[#21170F] py-6">
        <div className="mx-auto flex max-w-[1100px] items-center justify-between px-5 sm:px-8">
          <Link to="/" aria-label="TOYAM home" data-testid="legal-home-link"><Logo tone="ivory" /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#E8D6B7]"><ArrowLeft className="h-4 w-4" />Back</Link>
        </div>
      </header>
      <main className="mx-auto max-w-[820px] px-5 py-20 sm:px-8" data-testid={`legal-${kind}`}>
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 text-5xl sm:text-6xl">{c.title}</h1>
        <p className="mt-6 border-l-2 border-[#B18A4A] bg-[#E8D6B7]/40 px-5 py-4 text-sm text-[#5f584f]">
          Draft template — bracketed items must be completed and the full text reviewed by a qualified legal adviser before publication. This is not legal advice. Last updated: {L.lastUpdated}.
        </p>
        <div className="mt-12 space-y-10">
          {c.sections.map(([h, p]) => (
            <section key={h}>
              <h2 className="text-3xl">{h}</h2>
              <p className="body-lux mt-3">{p}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer onHome={false} />
    </>
  );
}
